export class User {
    email: string;
    senha: string;
}

